

//always start at the top of the page
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}
document.addEventListener("DOMContentLoaded", function () {
  // If there is a hash, let the browser scroll to the anchor.
  if (location.hash){
    var deeplink = location.hash.split("?")[0]
    if (deeplink){
        deeplink = deeplink.replace("#", "")
        const element = document.getElementById(deeplink); // Or use querySelector, etc.
        element.scrollIntoView();
    }
    
    return
  }

  // Respect back/forward restored positions.
  const nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (nav && nav.type === "back_forward") return;

  // Otherwise scroll to top on first frame after layout.
  requestAnimationFrame(function () {
    window.scrollTo(0, 0);
  });
});


window.intro_loaded = false




$(function(){


    window.main_video = document.getElementById("box-video");

    if (window.anim_handle != false && !window.box_set) {
        setup_anim_canvas()
    }
    else {
        $("main").addClass("stage-1")
    }

    $(".main-title h1").addClass("visible")


    if (!window.box_set) {
        do_producer_sig()
        setup_feat_prod_swiper()
        setup_mobile_stats_swiper()
        setup_stat_hovers()
        load_roast_profile()
    }

    
    if (get_query_variable("box-set") == "true"){
        do_box_set_child()
    }
    
    setup_hero_video_play_button()

    setup_misc_click_handlers()
    setupRcCtaBridge()
    setup_past_offerings_swiper()
    
    
})



function do_box_set_child(){
    $("body").addClass('box-set-child')
    var return_url = get_query_variable("return")
    var box_set_title = get_query_variable("title")
    $(".global-atc .container").html(`
        <div class="box-set-message">
            <a href='${return_url}'>&larr; Back to ${box_set_title}</a>
        </div>
    `)
	}

function setup_hero_video_play_button(){

    var wrapper = document.querySelector("[data-hero-video]")
    if (!wrapper) return

    var video = wrapper.querySelector("[data-hero-video-player]")
    var toggle_button = wrapper.querySelector("[data-hero-video-trigger]")
    if (!video || !toggle_button) return

    var is_wistia_player = video.tagName && video.tagName.toLowerCase() === "wistia-player"

    if (is_wistia_player) {
        toggle_button.addEventListener("click", function(){
            if (typeof video.play !== "function") return

            video.currentTime = 0
            video.muted = false
            video.volume = 1
            video.endVideoBehavior = "default"
            video.controlsVisibleOnLoad = true
            video.playPauseControl = true
            video.playBarControl = true
            video.volumeControl = true
            video.fullscreenControl = true
            video.settingsControl = true

            var play_promise = video.play()
            if (play_promise && typeof play_promise.catch === "function"){
                play_promise.catch(function(error){
                    console.warn("Unable to start hero video playback.", error)
                })
            }

            wrapper.classList.add("has-user-played-video")
            toggle_button.setAttribute("hidden", "hidden")
            toggle_button.setAttribute("aria-hidden", "true")
        })

        return
    }

    function sync_video_state(){
        var is_playing = !video.paused && !video.ended
        toggle_button.setAttribute("data-state", is_playing ? "playing" : "idle")
        toggle_button.setAttribute("aria-label", is_playing ? "Pause video" : "Play video")
    }

    toggle_button.addEventListener("click", function(){
        if (!video.paused && !video.ended){
            video.pause()
            return
        }

        if (video.ended) video.currentTime = 0

        var play_promise = video.play()
        if (play_promise && typeof play_promise.catch === "function"){
            play_promise.catch(function(error){
                console.warn("Unable to start hero video playback.", error)
            })
        }
    })

    video.addEventListener("play", sync_video_state)
    video.addEventListener("pause", sync_video_state)
    video.addEventListener("ended", sync_video_state)

    sync_video_state()
}

function do_producer_sig(){

    !(async function(){

        if (!window.producer_svg_url || window.producer_svg_url == "") return;

        
        const response = await fetch(window.producer_svg_url);
        const svgText = await response.text();

        // Find the DOM element using the selector
        const element = document.querySelector(".producer-sig");

        if (element && response.ok) {
            element.innerHTML = svgText;
        }

    })()

}


window.atc_clicks = 0
window.atc_error = false
function open_bottomless(){
    window.Bottomless.openWidgetModal(product.id, window.selected_variant.id, {
        variant_id:window.selected_variant.id,
        product_id:product.id,
        variant: window.selected_variant,
        product_title:"Test",
        selling_plan_id:"",
        frequency_num:"",
        quantity: "1",
        prepay: false,
        prepay_duration: 0,
        frequency_type_text:"Week(s)",
        meta:{}
    });
}

function set_button_loading($button, loading_text){
    if (!$button || !$button.length) return
    if (!$button.data("default-html")) {
        $button.data("default-html", $button.html())
    }
    $button.data("busy", true)
    $button.html(loading_text || "One Sec...")
    $(document).trigger("atc-state-updated")
}

function restore_button_loading($button, fallback_html){
    if (!$button || !$button.length) return
    var reset_html = $button.data("default-html")
    if (!reset_html || reset_html === "") {
        reset_html = fallback_html || "Subscribe"
    }
    $button.data("busy", false)
    $button.html(reset_html)
    $(document).trigger("atc-state-updated")
}

function add_subscription_to_cart($trigger_button){
    var $button = $trigger_button && $trigger_button.length ? $trigger_button : $(".subscribe-atc").first()

    if (!window.selected_variant || !window.selected_variant.id) return
    if ($button.length && ($button.hasClass("disabled") || $button.prop("disabled"))) return
    if ($(".global-atc .atc-left").hasClass("disabled")) return

    var id = window.selected_variant.id
    var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

    var $desktop_subscribe = $("#subscribe-selector")
    var $mobile_subscribe = $("#subscribe-selector-mobile")
    var use_mobile_frequency = $button.hasClass("mobile-only") && $mobile_subscribe.length
    var $active_subscribe = use_mobile_frequency ? $mobile_subscribe : ($desktop_subscribe.length ? $desktop_subscribe : $mobile_subscribe)
    if (!$active_subscribe.length) return

    var freq_num = $active_subscribe.val()
    var sub_id = $active_subscribe.find(":selected").attr("data-id")

    if (!sub_id) {
        var $first_plan = $active_subscribe.find("option[data-id]").first()
        if ($first_plan.length) {
            freq_num = $first_plan.val()
            sub_id = $first_plan.attr("data-id")
            $active_subscribe.val(freq_num).trigger("change")
            if ($active_subscribe[0] !== $desktop_subscribe[0] && $desktop_subscribe.length) {
                $desktop_subscribe.val(freq_num).trigger("change")
            }
            if ($active_subscribe[0] !== $mobile_subscribe[0] && $mobile_subscribe.length) {
                $mobile_subscribe.val(freq_num).trigger("change")
            }
        }
    }

    if (freq_num == "bottomless"){
        open_bottomless()
        return
    }

    var parsed_sub_id = parseInt(sub_id, 10)
    if (!freq_num || !parsed_sub_id) return

    set_button_loading($button, "One Sec...")

    var atc_options = {
        shipping_interval_frequency: freq_num,
        selling_plan: parsed_sub_id
    }

    CartJS.addItem(id, qty, atc_options, {
        "success": function(line_item){
            show_cart_confirm(line_item)
            $("header .cart-count").show()
            $button.html("Added!")
            setTimeout(function(){
                restore_button_loading($button, "Subscribe")
            }, 1200)
        },
        "error": function(e){
            console.log(e)
            $button.html("Error :(")
            setTimeout(function(){
                restore_button_loading($button, "Subscribe")
            }, 1400)
        }
    })
}

function clone_select_options($source_select, $target_select, filter_option){
    if (!$source_select.length || !$target_select.length) return
    $target_select.empty()

    $source_select.find("option").each(function(){
        var $source_option = $(this)
        var include_option = true
        if (typeof filter_option === "function") {
            include_option = filter_option($source_option)
        }
        if (!include_option) return

        var value = $source_option.val()
        if (typeof value === "undefined" || value === null || value === "") return

        var $new_option = $("<option></option>")
        $new_option.val(value)
        $new_option.text($source_option.text())
        $new_option.prop("disabled", $source_option.prop("disabled"))

        var data_id = $source_option.attr("data-id")
        if (typeof data_id !== "undefined") {
            $new_option.attr("data-id", data_id)
        }

        $target_select.append($new_option)
    })
}

function select_has_option($select, value){
    if (!$select.length) return false
    var desired = String(value)
    return $select.find("option").filter(function(){
        return $(this).val() === desired
    }).length > 0
}

function set_select_if_option_exists($select, value, should_trigger_change){
    if (!$select.length) return false
    var desired = String(value)
    if (!select_has_option($select, desired)) return false

    if (String($select.val()) !== desired){
        $select.val(desired)
        if (should_trigger_change){
            $select.trigger("change")
        }
    }
    return true
}

function setupRcCtaBridge(){
    var $rc_size = $("#rc-size-select")
    var $rc_frequency = $("#rc-frequency-select")
    var $rc_subscribe = $("#rc-subscribe-button")
    if (!$rc_size.length || !$rc_frequency.length || !$rc_subscribe.length) return

    var $variant_desktop = $("#variant-select")
    var $variant_mobile = $("#variant-select-mobile")
    var $subscribe_desktop = $("#subscribe-selector")
    var $subscribe_mobile = $("#subscribe-selector-mobile")

    var sync_lock = false

    function get_current_variant_value(){
        return $variant_desktop.val() || $variant_mobile.val() || ""
    }

    function get_current_frequency_value(){
        if ($subscribe_desktop.length){
            var desktop_value = $subscribe_desktop.val()
            var desktop_plan = $subscribe_desktop.find("option:selected").attr("data-id")
            if (desktop_value && desktop_plan) return desktop_value
        }

        if ($subscribe_mobile.length){
            var mobile_value = $subscribe_mobile.val()
            var mobile_plan = $subscribe_mobile.find("option:selected").attr("data-id")
            if (mobile_value && mobile_plan) return mobile_value
        }

        return ""
    }

    function hydrate_rc_controls(){
        var $size_source = $variant_desktop.length ? $variant_desktop : $variant_mobile
        clone_select_options($size_source, $rc_size)

        var $frequency_source = $subscribe_desktop.length ? $subscribe_desktop : $subscribe_mobile
        clone_select_options($frequency_source, $rc_frequency, function($option){
            if ($option.prop("disabled")) return false
            return !!$option.attr("data-id")
        })
    }

    function sync_rc_disabled_state(){
        var has_size_options = $rc_size.find("option").length > 0
        var has_frequency_options = $rc_frequency.find("option").length > 0

        var atc_left_disabled = $(".global-atc .atc-left").hasClass("disabled")
        var global_subscribe_disabled = $(".subscribe-atc").first().hasClass("disabled")
        var missing_variant = !(window.selected_variant && window.selected_variant.id)
        var variant_unavailable = !!(window.selected_variant && window.selected_variant.available === false)
        var selected_plan_id = $rc_frequency.find("option:selected").attr("data-id")
        var frequency_disabled = !has_frequency_options || atc_left_disabled

        $rc_size.prop("disabled", !has_size_options)
        $rc_frequency.prop("disabled", frequency_disabled)

        var disable_subscribe = frequency_disabled || !selected_plan_id || global_subscribe_disabled || missing_variant || variant_unavailable || !!$rc_subscribe.data("busy")
        $rc_subscribe.prop("disabled", disable_subscribe)
        $rc_subscribe.toggleClass("is-disabled", disable_subscribe)
        $rc_size.toggleClass("is-disabled", !has_size_options)
        $rc_frequency.toggleClass("is-disabled", frequency_disabled)
    }

    function sync_rc_from_canonical(){
        if (sync_lock) return

        var variant_value = get_current_variant_value()
        var frequency_value = get_current_frequency_value()

        if (variant_value && !select_has_option($rc_size, variant_value)){
            hydrate_rc_controls()
        }
        if (frequency_value && !select_has_option($rc_frequency, frequency_value)){
            hydrate_rc_controls()
        }

        if (variant_value){
            $rc_size.val(String(variant_value))
        } else if ($rc_size.find("option").length){
            $rc_size.prop("selectedIndex", 0)
        }

        if (frequency_value){
            $rc_frequency.val(String(frequency_value))
        } else if ($rc_frequency.find("option").length){
            $rc_frequency.prop("selectedIndex", 0)
        }

        sync_rc_disabled_state()
    }

    function push_variant_to_canonical(value){
        set_select_if_option_exists($variant_desktop, value, true)
        set_select_if_option_exists($variant_mobile, value, true)
    }

    function push_frequency_to_canonical(value){
        set_select_if_option_exists($subscribe_desktop, value, true)
        set_select_if_option_exists($subscribe_mobile, value, true)
    }

    $rc_size.off("change.rcCtaBridge").on("change.rcCtaBridge", function(){
        if (sync_lock) return
        sync_lock = true
        push_variant_to_canonical($(this).val())
        sync_lock = false
        sync_rc_from_canonical()
    })

    $rc_frequency.off("change.rcCtaBridge").on("change.rcCtaBridge", function(){
        if (sync_lock) return
        sync_lock = true
        push_frequency_to_canonical($(this).val())
        sync_lock = false
        sync_rc_from_canonical()
    })

    $rc_subscribe.off("click.rcCtaBridge").on("click.rcCtaBridge", function(e){
        e.preventDefault()
        if ($(this).prop("disabled")) return
        add_subscription_to_cart($(this))
    })

    var $canonical_controls = $variant_desktop.add($variant_mobile).add($subscribe_desktop).add($subscribe_mobile)
    $canonical_controls.off("change.rcCtaBridge").on("change.rcCtaBridge", function(){
        if (sync_lock) return
        sync_rc_from_canonical()
    })

    $(document).off("atc-state-updated.rcCtaBridge").on("atc-state-updated.rcCtaBridge", function(){
        sync_rc_disabled_state()
    })

    if (window.MutationObserver){
        var observer = new MutationObserver(function(){
            sync_rc_disabled_state()
        })
        var $atc_left = $(".global-atc .atc-left").first()
        var $global_subscribe = $(".subscribe-atc").first()
        var $global_atc_button = $(".atc-button").first()

        if ($atc_left.length) observer.observe($atc_left[0], {attributes: true, attributeFilter: ["class"]})
        if ($global_subscribe.length) observer.observe($global_subscribe[0], {attributes: true, attributeFilter: ["class"]})
        if ($global_atc_button.length) observer.observe($global_atc_button[0], {attributes: true, attributeFilter: ["class"]})
    }

    hydrate_rc_controls()
    sync_rc_from_canonical()
}

function setup_misc_click_handlers(){

    



    //ATC - desktop (non-subscribe)
    $(".atc-button.desktop-only").click(function(){


        var that = $(this)

        window.atc_clicks++

        var already_did = false
        if (that.html() == "Going..." || that.html() == "You did it!" || that.html() == "Again, again!!"){
            already_did = true
        }

        that.html("Going...")


        
        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1

        CartJS.addItem(id,qty, {}, {
            "success":function(line_item, msg){
                show_cart_confirm(line_item)
                $("header .cart-count").show()
                if (already_did){
                    if (window.atc_clicks > 3){
                        that.html("Hehe, it tickles... 🤮")
                    }
                    else {
                        that.html("Again, again!!")
                    }
                    
                }
                else {
                    that.html("You did it!")
                }
                
            },
            "error":function(e){
                if (window.atc_error){
                    that.html("Please call us...")
                    window.atc_error = false
                }
                else {
                    window.atc_error = true
                    that.html("Error! :(")
                }
                
                console.log(e)
                //alert("We weren't able to add t")
            }
        });


        //get qty
        //get variant id

        //SEND IT, BRUH
    })

    //ATC - mobile (dual mode both one-time and subscription)
    $(".atc-button.mobile-only").click(function(){
        


        var id = window.selected_variant.id
        var qty = window.get_global_atc_quantity ? window.get_global_atc_quantity() : 1



        var atc_options = {}
        var sub_id = $("#subscribe-selector-mobile").find(':selected').attr('data-id');

        var freq_num = $("#subscribe-selector-mobile").val()
        if (freq_num == "bottomless"){
            //show popup
            open_bottomless()
            return
        }
        if (freq_num != "one-time"){
            atc_options = {
                shipping_interval_frequency:freq_num,
                selling_plan:parseInt(sub_id)
            }
        }

        var that = $(this)
        that.html("Going...")


        CartJS.addItem(id,qty, atc_options, {
            "success":function(line_item){
            show_cart_confirm(line_item)
                $("header .cart-count").show()
                that.html("Added!")
            },
            "error":function(e){
                //console.log(e)
                that.html("Error :(")
            }
        });

    })

    $(".trans-learn-more").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })


    $(".trans-virtue").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    $(".testing .trans-tab").click(function(){
        
        var active_tab = $(".testing .trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".testing .trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })


    $(".fin-trans .trans-tab").click(function(){
        
        var active_tab = $(".fin-trans .trans-tab.active")
        var active_video = active_tab.find(".trans-img video")[0]
        if (active_video)
            active_video.pause()

        $(".fin-trans .trans-tab.active").removeClass("active")
        
        
        var new_video = $(this).find(".trans-img video")[0]
        $(this).addClass("active")

        //if (window.innerWidth < 800)
            //$(this)[0].scrollIntoView({ behavior: "smooth" }); 

        if (!new_video) return
        new_video.play()
        

    })


    $(".a-stat-desc .button").click(function(){
        $(".coffee-modal.active").removeClass("active")
        var this_id = $(this).attr("data-id")
        $("html").addClass("stuck")
        $("#" + this_id).addClass("active")
    })

    //subscribe click
    $(".subscribe-atc").click(function(){
        add_subscription_to_cart($(this))
    })

    $(".bottomless-help").click(function(){
        open_bottomless()
    })

    //showing and hiding the story popup
    $(".story-more-trigger").click(function(){
        $("html").addClass("stuck")
        $("#story-more").addClass("active")
    })
    
    //generic modal closing
    $(".modal-close").click(function(){
        $("html").removeClass("stuck")
        $(".coffee-modal.active").removeClass("active")
    })

    //showing and hiding brew guides for espresso/filter and english/spanish
    $(".guides .lang-selector button").click(function(){
        $(".lang-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    $(".guides .guide-selector button").click(function(){
        $(".guide-selector button.active").removeClass("active")
        $(this).addClass("active")
        brew_video_display_check()
    })
    $(".guides .all-selector button").click(function(){
        $(".all-selector button.active").removeClass("active")
        $(this).addClass("active")
        var this_id = $(this).attr("data-guide")
        $(".guide-body.active").removeClass("active")
        $(".guide-body[data-guide='"+this_id+"']").addClass("active")
        $(".brew-timer-container.active").removeClass("active")
        $(".brew-timer-container[data-guide='"+this_id+"']").addClass("active")
    })

    //addon products
    $(".add-addon").click(function(){
        var variant = parseInt($(this).attr("data-variant-id"))
        var that = $(this)
        that.html("Going...")
        CartJS.addItem(variant,1, {}, {
            "success":function(line_item){
                that.html("Done!")
                show_cart_confirm(line_item)
                },
            "error":function(){
                that.html("Error :(")
            }
        });

    })

    function brew_video_display_check() {
        const lang = $(".lang-selector button.active").attr("data-lang") || "en";

        // source of truth on load
        const guide =
            $(".guides .all-selector button.active").attr("data-guide") ||
            $(".guides .all-selector button").first().attr("data-guide");

        if (!guide) return;

        // --- guide body ---
        $(".guide-body.active").removeClass("active");

        // Prefer lang match if guide bodies have data-lang, otherwise fall back to guide-only
        const $byLang = $(`.guide-body[data-guide='${guide}'][data-lang='${lang}']`);
        const $byGuide = $(`.guide-body[data-guide='${guide}']`);

        ($byLang.length ? $byLang : $byGuide).addClass("active");

        // --- timer ---
        $(".brew-timer-container.active").removeClass("active");
        $(`.brew-timer-container[data-guide='${guide}']`).addClass("active");
    }

    $(function () {
    brew_video_display_check();
    });
}


function load_360(){
    frameCount = 167
    for (let i = 46; i < frameCount; i++) {
        const img = new Image();
        images.push(img);
    }
    for (var j in images){
        images[j].src = currentFrame(parseInt(j));
    }
    loadAllImages(images).then(() => {
        $("main").addClass("spin-ready")
        render_canvas()
    }).catch(error => {
        console.error(error);
    });
}

const currentFrame = index => (
        `https://static.onyxcontent.com/pdp-frames/${window.anim_handle}/${window.anim_handle}_${(index).toString().padStart(4, '0')}.webp`
    );

function setup_anim_canvas(){

    window.canvas = document.getElementById("box-canvas");
    window.context = canvas.getContext("2d");
    window.canvas_w = 0
    window.canvas_h = 0

    queue_canvas_resize()
    window.addEventListener("resize", queue_canvas_resize)
    window.addEventListener("orientationchange", queue_canvas_resize)

    if (typeof ResizeObserver !== "undefined") {
        if (window.canvas_resize_observer) {
            window.canvas_resize_observer.disconnect()
        }

        var resize_target = canvas.closest(".stat-circle") || canvas.closest(".box-video") || canvas.parentElement
        if (resize_target) {
            window.canvas_resize_observer = new ResizeObserver(function(){
                queue_canvas_resize()
            })
            window.canvas_resize_observer.observe(resize_target)
        }
    }

    var frameCount = 46; //real number is 167, but we load the first 45 to be speedy
    

    window.images = []
    window.boxframes = {
        frame: 45
    };

    for (let i = 0; i < frameCount; i++) {
        if (i < 45) images.push({})
        else {
            const img = new Image();
            images.push(img);
        }
    }


    for (var j in images){
        images[j].src = currentFrame(parseInt(j));
    }
    
    loadAllImages(images).then(() => {
        console.log("all animation frames loaded")
        window.intro_loaded = true
        intro_animation();

        load_360()
        
    }).catch(error => {
        console.error(error);
    });

    





    setup_scrubber()

}



function fix_dpi(canvas) {
        if (!canvas || !canvas.parentElement) return

        let size_source = canvas.closest(".box-video") || canvas.parentElement
        let parentWidth = size_source ? size_source.offsetWidth : 0;
        let parentHeight = size_source ? size_source.offsetHeight : 0;
        if (!parentWidth || !parentHeight) return
        
        let ctx = canvas.getContext('2d');
        if (!ctx) return
        let dpr = window.devicePixelRatio || 1;
        let bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio ||
                    ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio ||
                    ctx.backingStorePixelRatio || 1;

        let ratio = dpr / bsr;


        canvas.style.width = parentWidth + 'px'; // Set canvas style width to 100% of parent width
        canvas.style.height = parentHeight + 'px';
        canvas.width = parentWidth * ratio; // Adjust canvas element width for high DPI
        canvas.height = parentHeight * ratio; // Adjust canvas element height similarly if necessary
        ctx.setTransform(1, 0, 0, 1, 0, 0); // Prevent cumulative scaling on repeated resize events
        ctx.scale(ratio, ratio); // Scale the context to counteract the increase in physical size
                                    // to keep drawings at intended size

        window.canvas_w = parentWidth
        window.canvas_h = parentHeight

        window.context = ctx
}

function queue_canvas_resize(){
    if (!window.canvas) return

    if (window.canvas_resize_raf) {
        cancelAnimationFrame(window.canvas_resize_raf)
    }

    window.canvas_resize_raf = requestAnimationFrame(function(){
        fix_dpi(window.canvas)
        if (window.context && window.images && window.images.length) {
            render_canvas()
        }
    })
}


function render_canvas() {
  window.context.clearRect(0, 0, window.canvas.width, window.canvas.height);
  window.context.drawImage(images[boxframes.frame], 0, 0, window.canvas_w, window.canvas_h); 
}


function loadAllImages(imageElements) {
    // Create a promise for each image load
    let promises = Array.from(imageElements).map(img => new Promise((resolve, reject) => {
        // If the image is already loaded
        if (!(img instanceof HTMLImageElement)) resolve()

        if (img.complete && img.naturalHeight !== 0) {
            resolve();
        } else {
            // Set up load and error event listeners
            img.onload = () => resolve();
            img.onerror = () => reject(new Error(`Failed to load image at ${img.src}`));
        }
    }));

    // Use Promise.all to wait for all promises to resolve
    return Promise.all(promises);
}


window.box_anime = null
window.last_intro_frame = 0
// function video_stage_0(){
//     if (window.anim_handle == false)
//         return
    

//     if (window.box_anime)
//         window.box_anime.pause()

//     window.box_anime = anime({
//         targets: window.boxframes,
//         frame: 1,
//         duration:1000,
//         easing: 'easeInOutQuad',
//         round: 1,
//         update: function() {
//             render_canvas()
//         }
//     });
//     //playVideoFrameByFrame(window.main_video, video_frame_stage_0)
// }

function video_stage_1(){

    if (window.anim_handle == false)
        return


    if (window.box_anime)
        window.box_anime.pause()

    

   
    //animate back to center (from left)
    if (window.boxframes == 45){
        render_canvas()
        $("main").addClass("intro-played")
        return
    }
    else if (window.boxframes.frame < 106){
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 45,
            duration:1000,
            easing: 'linear',
            round: 1,
            update: function() {
                
                if (window.last_intro_frame == window.boxframes.frame) return

                window.last_intro_frame = window.boxframes.frame

                render_canvas()
            },
            complete: function(){
                $("main").addClass("intro-played")
            }
        });
    }
    else { //animate back to center (from right)
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 108,
            duration:1000,
            easing: 'linear',
            round: 1,
            update: function() {
                render_canvas()
            },
            complete: function(){
                $("main").addClass("intro-played")
                $(".box-video").addClass("clipping")
            }
        });
    }
    
    //playVideoFrameByFrame(window.main_video, video_frame_stage_1)
}
function video_stage_2(){

    console.log("video stage 2")
    
    if (window.anim_handle == false)
        return

    if (window.loaded_360 == false){
        return
    }

    if (window.box_anime)
        window.box_anime.pause()
   
    if (window.boxframes.frame >= 108) {
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 140,
            duration:1000,
            easing: 'easeOutQuad',
            round: 1,
            update: function() {
                render_canvas()
            }
        });
    }
    else {
        //this is hard because sometimes the transition frames won't be exactly sequential
        window.box_anime = anime({
            targets: window.boxframes,
            frame: 80,
            duration:1000,
            easing: 'easeOutQuad',
            round: 1,
            update: function() {
                render_canvas()
            }
        });
    }
        
    

    
}

function intro_animation(){

    if (window.anim_handle == false){
        return
    }
        
    window.boxframes.frame = 45
    render_canvas()

    $("main").addClass("stage-1")
    video_stage_1()


    
}


function setup_scrubber() {

    //scrub frame-by-frame
    // const base_scrubby = anime({
    //     targets: window.boxframes,
    //     frame: 167,
    //     duration:167,
    //     easing: 'linear',
    //     round: 1,
    //     autoplay:false,
    //     update: function(anim) {
    //         console.log("anime updated, frame: " + window.boxframes.frame)
    //         render_canvas()
    //     }
    // });

    var seekProgressEl = document.querySelector('#slider-input');

    if (!seekProgressEl) return


    //move the arrow up and down a little to make it seem
    //like its part of the circle track
    const input_scrubby = anime({
        targets: "#slider-input",
        duration:1000,
        direction: 'alternate',
        keyframes: [
            {translateY: 0},
            {translateY: "-2.5vh"},
        ],
        easing: 'easeInCirc',
        autoplay:false,
    })


    //when the slider changes value, scrub the anime
    seekProgressEl.oninput = function() {


        var progress = parseInt(seekProgressEl.value)
        if (progress >= 51){
            
            //animate from frame 45 to frame X
            var desired_frame = 45 + (progress-50)
            window.boxframes.frame = desired_frame
            render_canvas()
            //base_scrubby.seek(desired_frame);
        }
        else if (progress <= 49){
            //animate from frame X to frame 167
            var desired_frame = 106 + (50 - progress)
            window.boxframes.frame = desired_frame
            render_canvas()
        }
        else {
            window.boxframes.frame = 46;
            render_canvas()
        }
        //base_scrubby.seek(base_scrubby.duration * (seekProgressEl.value / 100));
        
        if (seekProgressEl.value > 50)
            input_scrubby.seek(input_scrubby.duration * (seekProgressEl.value / 100));
        else 
            input_scrubby.seek(input_scrubby.duration * ( (100 - seekProgressEl.value) / 100));
    };
}




function setup_feat_prod_swiper() {

    var feat_prod_swipers = document.querySelectorAll(".feat-prod-slider .swiper")
    for (var swip of feat_prod_swipers){
        const swiper = new Swiper(swip, {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            // observer: true, 
            // observeParents: true,
            mousewheel: true,
            // And if we need scrollbar
            scrollbar: {
                draggable: true,
                el: '.swiper-scrollbar',
            },
        });
    }

}

function setup_mobile_stats_swiper() {

    window.all_m_stats = $(".mobile-stats-slider .stat-m-icon")
    var circle_radius = 140; // what are the units here??

    //this whole thing is a shit-show. 
    //Changing the slides_per_view breaks the layout
    //circle_radius means nothing, and is actually inversely proportional to the actual circle size

    var slides_per_view = 7
    var space_between = 0
    var total_slides = 11.0
    //theres a weird relationship between swiper progress and which slides are visible
    var chunk_size = 1.0 / (total_slides-1) //minus 1 because the slides are centered? This is right.
    var chunk_window_size = slides_per_view * chunk_size + chunk_size
    var baseline_to_clear = Math.ceil(slides_per_view/2.0)
    var additional = (slides_per_view % 1)/2.0

    function mapValue(x) {
        return circle_radius - (circle_radius * Math.sin(Math.PI * x))
    }

    const swiper = new Swiper('.mobile-stats-slider .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: slides_per_view,
        initialSlide: 5,
        //loop:true,
        speed:200,
        slideToClickedSlide: true,
        centeredSlides: true,
        spaceBetween: space_between,
        // observer: true, 
        // observeParents: true,
        on: {
            slideChange: function(swip){
                var active_slide = swip.slides[swip.activeIndex]

                var stat_id = $(active_slide).attr("data-stat-id")
                $(".a-stat-desc").removeClass("in")

                if (stat_id == "abstract"){
                    $(".a-stat-desc.blurb").removeClass("out")
                }
                else if (stat_id != "" && stat_id){
                    //console.log("adding out??")
                    //console.log(stat_id)
                    $(".a-stat-desc.blurb").addClass("out")
                }
                
                var stat_desc = $(".a-stat-desc[data-stat-id='"+stat_id+"']")
                stat_desc.addClass("in")


                //swap out the inner text
            },
            touchStart: function(){
                $(".mobile-stats-slider").addClass("touching")
            },
            touchEnd: function(){
                $(".mobile-stats-slider").removeClass("touching")
            },
            progress: function(swip, progress){
                for (var i in window.all_m_stats){
                    let el = window.all_m_stats[i]
                    
                    var start_chunk = (i-baseline_to_clear - additional) * chunk_size
                    var end_chunk = start_chunk + chunk_window_size

                    
                    if (progress > start_chunk && progress < end_chunk){
                        //animating this specific slide!
                        var percent_through = (progress-start_chunk) / (end_chunk-start_chunk) //this is WRONG
                        var offset = mapValue(percent_through)
                        el.style.transform = `translate3d(0px, -${offset}px, 0)`;
                    }


                }

            },
        },
        
        // And if we need scrollbar
        scrollbar: {
            draggable: true,
            el: '.swiper-scrollbar',
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

function rc_get_slide_year(slide){
    if (!slide) return ""
    if (slide.hasAttribute("data-upcoming")) return ""

    var data_year = slide.getAttribute("data-year")
    if (data_year) return data_year

    var data_week = slide.getAttribute("data-week") || ""
    if (data_week.length >= 4) return data_week.substring(0, 4)

    return ""
}

function sync_past_offerings_timeline(swiper, section){
    if (!swiper || !section) return

    var timeline_indexes = section._past_offerings_timeline_indexes || []
    if (!timeline_indexes.length) return

    var active_index = typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0
    if (active_index < 0) active_index = 0

    var active_timeline_index = 0
    for (var timeline_i = 0; timeline_i < timeline_indexes.length; timeline_i++) {
        if (timeline_indexes[timeline_i] <= active_index) {
            active_timeline_index = timeline_i
            continue
        }
        break
    }

    var progress = section.querySelector("[data-past-offerings-progress]")
    if (!progress) return

    var ratio = timeline_indexes.length <= 1 ? 1 : (active_timeline_index / (timeline_indexes.length - 1))
    progress.style.width = (ratio * 100) + "%"
}

function build_past_offerings_timeline(swiper, section){
    if (!swiper || !section) return

    var ticks_wrap = section.querySelector("[data-past-offerings-ticks]")
    var years_wrap = section.querySelector("[data-past-offerings-years]")
    if (!ticks_wrap || !years_wrap) return

    var slides = Array.prototype.slice.call(swiper.slides || [])
    if (!slides.length) return

    var timeline_slides = []
    for (var slide_index = 0; slide_index < slides.length; slide_index++) {
        if (slides[slide_index].hasAttribute("data-upcoming")) continue

        timeline_slides.push({
            slide: slides[slide_index],
            swiper_index: slide_index
        })
    }
    if (!timeline_slides.length) return

    ticks_wrap.innerHTML = ""
    years_wrap.innerHTML = ""

    var year_groups = []
    for (var timeline_index = 0; timeline_index < timeline_slides.length; timeline_index++) {
        var timeline_item = timeline_slides[timeline_index]
        var timeline_year = rc_get_slide_year(timeline_item.slide) || ""
        var existing_group = year_groups[year_groups.length - 1]

        if (!existing_group || existing_group.year !== timeline_year) {
            existing_group = {
                year: timeline_year,
                items: []
            }
            year_groups.push(existing_group)
        }

        existing_group.items.push({
            slide: timeline_item.slide,
            swiper_index: timeline_item.swiper_index,
            timeline_index: timeline_index
        })
    }

    // Include all slides for track fill + drag so upcoming endcap slides
    // contribute to total progress distance.
    section._past_offerings_timeline_indexes = slides.map(function(_slide, index){
        return index
    })

    var year_positions = []
    var year_count = year_groups.length
    for (var year_index = 0; year_index < year_count; year_index++) {
        var year_position_ratio = year_count <= 1 ? 0.5 : ((year_index + 0.5) / year_count)
        year_positions.push(year_position_ratio)
    }

    for (var group_index = 0; group_index < year_groups.length; group_index++) {
        var year_group = year_groups[group_index]
        var marker = document.createElement("div")
        marker.className = "past-offerings-year-marker"
        marker.style.left = (year_positions[group_index] * 100) + "%"

        var year_label = document.createElement("span")
        year_label.className = "past-offerings-year-label"
        year_label.textContent = year_group.year
        marker.appendChild(year_label)
        years_wrap.appendChild(marker)
    }

    // Tick marks intentionally removed; keep only year markers.

    sync_past_offerings_timeline(swiper, section)
}

function setup_past_offerings_timeline_drag(swiper, section){
    if (!swiper || !section) return

    var track = section.querySelector(".past-offerings-track")
    if (!track) return

    var is_dragging = false
    var last_target_swiper_index = -1
    var drag_slide_speed = Math.min(((swiper && swiper.params && swiper.params.speed) || 600), 220)

    function slide_to_position(client_x){
        var timeline_indexes = section._past_offerings_timeline_indexes || []
        if (!timeline_indexes.length) return

        var rect = track.getBoundingClientRect()
        if (!rect.width) return

        var ratio = (client_x - rect.left) / rect.width
        if (ratio < 0) ratio = 0
        if (ratio > 1) ratio = 1

        var target_timeline_index = Math.round(ratio * (timeline_indexes.length - 1))
        var target_swiper_index = timeline_indexes[target_timeline_index]
        if (typeof target_swiper_index !== "number") return
        if (target_swiper_index === last_target_swiper_index) return

        last_target_swiper_index = target_swiper_index
        swiper.slideTo(target_swiper_index, drag_slide_speed)
    }

    function on_pointer_down(event){
        is_dragging = true
        track.classList.add("is-dragging")
        track.setPointerCapture(event.pointerId)
        slide_to_position(event.clientX)
        event.preventDefault()
    }

    function on_pointer_move(event){
        if (!is_dragging) return
        slide_to_position(event.clientX)
    }

    function on_pointer_up(event){
        is_dragging = false
        last_target_swiper_index = -1
        track.classList.remove("is-dragging")
        if (track.hasPointerCapture(event.pointerId)) {
            track.releasePointerCapture(event.pointerId)
        }
    }

    track.removeEventListener("pointerdown", track._rc_pointer_down)
    track.removeEventListener("pointermove", track._rc_pointer_move)
    track.removeEventListener("pointerup", track._rc_pointer_up)
    track.removeEventListener("pointercancel", track._rc_pointer_up)

    track._rc_pointer_down = on_pointer_down
    track._rc_pointer_move = on_pointer_move
    track._rc_pointer_up = on_pointer_up

    track.addEventListener("pointerdown", track._rc_pointer_down)
    track.addEventListener("pointermove", track._rc_pointer_move)
    track.addEventListener("pointerup", track._rc_pointer_up)
    track.addEventListener("pointercancel", track._rc_pointer_up)
}

function sync_past_offerings_upcoming_height(section){
    if (!section) return

    var upcoming_slides = section.querySelectorAll(".past-offering-slide-upcoming")
    if (!upcoming_slides.length) return

    var real_slides = section.querySelectorAll(".past-offering-slide:not(.past-offering-slide-upcoming)")
    if (!real_slides.length) return

    for (var upcoming_index = 0; upcoming_index < upcoming_slides.length; upcoming_index++) {
        upcoming_slides[upcoming_index].style.height = ""
        upcoming_slides[upcoming_index].style.minHeight = ""
    }

    var max_height = 0
    for (var i = 0; i < real_slides.length; i++) {
        var slide_height = real_slides[i].offsetHeight
        if (slide_height > max_height) max_height = slide_height
    }

    if (max_height > 0) {
        for (var set_index = 0; set_index < upcoming_slides.length; set_index++) {
            upcoming_slides[set_index].style.height = max_height + "px"
            upcoming_slides[set_index].style.minHeight = max_height + "px"
        }
    }
}

function setup_past_offerings_swiper() {
    var slider = document.querySelector("[data-past-offerings-swiper]")
    if (!slider) return
    if (typeof Swiper === "undefined") return

    var section = slider.closest("[data-past-offerings]")
    if (!section) return

    var next_button = section.querySelector(".past-offerings-next")
    var prev_button = section.querySelector(".past-offerings-prev")
    var slide_elements = Array.prototype.slice.call(slider.querySelectorAll(".past-offering-slide"))
    var initial_index = 0
    for (var i = slide_elements.length - 1; i >= 0; i--) {
        if (!slide_elements[i].hasAttribute("data-upcoming")) {
            initial_index = i
            break
        }
    }

    var swiper_config = {
        direction: "horizontal",
        loop: false,
        slidesPerView: 1.08,
        centeredSlides: true,
        initialSlide: initial_index,
        spaceBetween: 14,
        speed: 600,
        grabCursor: true,
        watchOverflow: true,
        keyboard: {
            enabled: true
        },
        breakpoints: {
            700: {
                slidesPerView: 1.3,
                spaceBetween: 18
            },
            1050: {
                slidesPerView: 3,
                spaceBetween: 24
            }
        },
        on: {
            init: function(swiper_instance){
                build_past_offerings_timeline(swiper_instance, section)
                sync_past_offerings_upcoming_height(section)
            },
            slideChange: function(swiper_instance){
                sync_past_offerings_timeline(swiper_instance, section)
            },
            resize: function(swiper_instance){
                build_past_offerings_timeline(swiper_instance, section)
                sync_past_offerings_upcoming_height(section)
            }
        }
    }

    if (next_button && prev_button) {
        swiper_config.navigation = {
            nextEl: next_button,
            prevEl: prev_button
        }
    }

    var past_offerings_swiper = new Swiper(slider, swiper_config)
    build_past_offerings_timeline(past_offerings_swiper, section)
    sync_past_offerings_timeline(past_offerings_swiper, section)
    sync_past_offerings_upcoming_height(section)
    setup_past_offerings_timeline_drag(past_offerings_swiper, section)

    var slide_images = slider.querySelectorAll(".past-offering-slide img")
    for (var img_index = 0; img_index < slide_images.length; img_index++) {
        var image = slide_images[img_index]
        if (image.complete) continue
        image.addEventListener("load", function(){
            sync_past_offerings_upcoming_height(section)
        })
    }
}



function load_roast_profile(){
    var profile_id = $("#roast-profile").attr("data-id")
    if (profile_id == "" || !profile_id) return


    var base_url = "https://onyx-data.herokuapp.com/api/cropster/most-recent-roast?profile=" + profile_id
    fetch(base_url)
        .then(response => response.json())
        .then(function(data){
            display_chart(data)
            display_roast_misc_data(data)

            watch_it(document.querySelector("#chartdiv"), function(){amcharts_animation()})
        })
        .catch(function(){
            $("#roast-profile").hide();
        });


    function display_chart(coffee_data){

            if (!coffee_data.batch.data) {
                console.log("insufficient data")
                $("#roast-profile").hide();
                return
            }


            function calculateRateOfRise(series, options = {}) {
                const result = [];

                for (let i = 1; i < series.length; i++) {
                    const prev = series[i - 1];
                    const curr = series[i];

                    const deltaTime = curr.time - prev.time;
                    const deltaValue = curr.value - prev.value;

                    var rate = deltaTime !== 0 ? deltaValue / deltaTime : 0;

                    if (rate < 0) rate = 0;

                    result.push({
                        time: curr.time,
                        value: (rate * 30.0)
                    });
                }

                // Step 2: Optional smoothing (moving average)
                if (options.smooth && options.windowSize && options.windowSize > 1) {
                    const smoothed = [];
                    const w = options.windowSize;

                    for (let i = 0; i < result.length; i++) {
                    let sum = 0;
                    let count = 0;

                    for (let j = i - Math.floor(w / 2); j <= i + Math.floor(w / 2); j++) {
                        if (j >= 0 && j < result.length) {
                        sum += result[j].value;
                        count++;
                        }
                    }

                    smoothed.push({
                        time: result[i].time,
                        value: Math.round((sum / count) * 10) / 10
                    });
                    }

                    return smoothed;
                }
                return result;
            }



            //do amcharts stuff here
            am5.ready(function() {

                var raw_data = coffee_data.batch.data

                // Create root element
                // https://www.amcharts.com/docs/v5/getting-started/#Root_element
                window.chart_root = am5.Root.new("chartdiv");

                // Create chart
                // https://www.amcharts.com/docs/v5/charts/xy-chart/
                var chart = chart_root.container.children.push(am5xy.XYChart.new(chart_root, {
                    maxTooltipDistance: 5
                }));






                // Create axes
                // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(chart_root, {
                    baseInterval: {
                        timeUnit: "second",
                        count: 1
                    },
                    strictMinMax: true,
                    renderer: am5xy.AxisRendererX.new(chart_root, {}),
                    tooltip: am5.Tooltip.new(chart_root, {})
                }));

                let xRenderer = xAxis.get("renderer");
                xRenderer.labels.template.setAll({
                    fill: am5.color(0xAAAAAA),
                    fontSize: "0.8em"
                });
                xAxis.set("tooltip", am5.Tooltip.new(chart_root, {
                    forceHidden: true
                }));

                var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(chart_root, {
                    renderer: am5xy.AxisRendererY.new(chart_root, {})
                }));
                let yRenderer = yAxis.get("renderer");
                yRenderer.grid.template.setAll({
                    stroke: am5.color(0xDDDDDD),
                    strokeWidth: 2
                });
                yRenderer.labels.template.setAll({
                    fill: am5.color(0xAAAAAA),
                    fontSize: "0.8em"
                });


                // Add series
                // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                var tooltip = am5.Tooltip.new(chart_root, {
                    getFillFromSprite: false,
                    pointerOrientation: "horizontal",
                    labelText: "[fontFamily: Andale]{valueY}°F\n{valueX} Sec.[/]",
                    autoTextColor: false
                })
                tooltip.get("background").setAll({
                    fill: am5.color(0x000000),
                    fillOpacity: 0.3,
                    strokeOpacity: 0.0
                });
                tooltip.label.setAll({
                    fill: am5.color(0xA57044)
                });
                window.roast_line_1 = chart.series.push(am5xy.SmoothedXLineSeries.new(chart_root, {
                    name: "Bean Temp",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "value",
                    valueXField: "time",
                    stroke: am5.color(0xA57044),
                    legendValueText: "{valueY}",
                    tooltip: tooltip
                }));

                
                var data = []
                for (var i in raw_data){
                    data.push({time: parseInt(i), value: (raw_data[i] / 10) })
                }
                roast_line_1.data.setAll(data);
                roast_line_1.appear();

                // roast_line_1.strokes.template.setAll({
                //     strokeDasharray: [0, 1600], // Hide the line initially
                // });

                var tooltip1 = am5.Tooltip.new(chart_root, {
                    getFillFromSprite: false,
                    pointerOrientation: "horizontal",
                    labelText: "[fontFamily: Andale] {valueY}Δ°F/s\n{valueX} Sec.[/]",
                    autoTextColor: false
                })
                tooltip1.get("background").setAll({
                    fill: am5.color(0x000000),
                    fillOpacity: 0.3,
                    strokeOpacity: 0.0
                });
                tooltip1.label.setAll({
                    fill: am5.color(0xa12f30)
                });
                var yAxis1 = chart.yAxes.push(am5xy.ValueAxis.new(chart_root, {
                    renderer: am5xy.AxisRendererY.new(chart_root, {opposite: true})
                }));
                let yRenderer1 = yAxis1.get("renderer");
                yRenderer1.grid.template.setAll({
                    stroke: am5.color(0xDDDDDD),
                    strokeWidth: 2
                });
                yRenderer1.labels.template.setAll({
                    fill: am5.color(0xAAAAAA),
                    fontSize: "0.8em"
                });


                var ror_data = calculateRateOfRise(data, {smooth: true, windowSize: 30})
                window.roast_line_2 = chart.series.push(am5xy.SmoothedXLineSeries.new(chart_root, {
                    name: "RoR Temp",
                    xAxis: xAxis,
                    yAxis: yAxis1,
                    valueYField: "value",
                    valueXField: "time",
                    stroke: am5.color(0xa12f30),
                    legendValueText: "{valueY}",
                    tooltip: tooltip1
                }));

                roast_line_2.data.setAll(ror_data);
                roast_line_2.appear();

                // roast_line_1.strokes.template.setAll({
                //     strokeDasharray: [0, 1600], // Hide the line initially
                // });



            // Add series
            // https://www.amcharts.com/docs/v5/charts/xy-chart/series/







                window.amcharts_animation = function(){
                    var myObject = {
                        strokeOffset: 0,
                    }
                    anime({
                        targets: myObject,
                        strokeOffset: 1600,
                        easing: 'linear',
                        round: 1,
                        duration: 4000,
                        update: function() {
                            // roast_line_1.strokes.template._settings.strokeDasharray = [myObject.strokeOffset, 1600]
                            // roast_line_1.appear()

                            // roast_line_2.strokes.template._settings.strokeDasharray = [myObject.strokeOffset, 1600]
                            // roast_line_2.appear()
                        }
                    });
                }


            // Add cursor
            var cursor = chart.set("cursor", am5xy.XYCursor.new(chart_root, {
            behavior: "none"
            }));
            cursor.lineY.set("visible", false);

            cursor.lineX.setAll({
            stroke: am5.color(0xAAAAAA),
            strokeWidth: 1,
            strokeDasharray: []
            });
            cursor.selection.setAll({
            fill: am5.color(0x000055),
            fillOpacity: 0.2
            });



            // Add legend
            // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
            // var legend = chart.leftAxesContainer.children.unshift(am5.Legend.new(root, {
            //   width: 200,
            //   paddingLeft: 15,
            //   height: am5.percent(100)
            // }));



            // Make stuff animate on load
            // https://www.amcharts.com/docs/v5/concepts/animations/
            chart.appear(1000, 100);

            }); // end am5.ready()


    }


    function display_roast_misc_data(data){
        console.log(data.batch)
        $("#roast-date").html(formatFriendlyDate(data.batch.date))
        $("#roast-id").html("#" + data.batch.batch_number)
        $("#roast-tech").html(data.batch.roaster)
        $("#roast-charge").html(data.batch.start_temp + " °F")
        $("#roast-finish").html(data.batch.end_temp + " °F")
        $("#roast-duration").html( Math.round( (data.batch.data.length / 60), 1) + " minutes")
        
    }

    function formatFriendlyDate(epochString) {
        const date = new Date(Number(epochString));
        const now = new Date();

        const isToday = date.toDateString() === now.toDateString();
        const yesterday = new Date();
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.toDateString() === yesterday.toDateString();

        const options = { hour: 'numeric', minute: 'numeric', hour12: true };
        const timeString = date.toLocaleTimeString(undefined, options).toLowerCase();

        if (isToday) {
            return `Today at ${timeString}`;
        } else if (isYesterday) {
            return `Yesterday at ${timeString}`;
        } else {
            const dateOptions = { month: 'short', day: 'numeric' };
            return date.toLocaleDateString(undefined, dateOptions);
        }
    }
}


function setup_stat_hovers(){

    //we want the stat hovers to be relatively sticky

    $(".stage").hover(function(){
        //nothing?
        $(".stage").addClass("hovered")
    }, function(){

        if (window.innerWidth < 800){
            return
        }

        console.log("stat line hover out")
        $(".stage").removeClass("hovered")
        $(".stage").removeClass("darkened")
        $(".a-stat-desc.blurb").removeClass("out")
        $(".a-stat-desc").removeClass("in")
        $(".a-stat.active").removeClass("active")
        $(".stat-vids img.in").removeClass("in")
    })



    $(".stat-text").hover(function(){
        //hover in!

        var stat_id = $(this).parent().attr("data-stat-id")
        
        console.log("stat text hover")
        $(".a-stat-desc.blurb").removeClass("out")
        $(".a-stat-desc").removeClass("in")
        $(".a-stat.active").removeClass("active")
        $(".stat-vids img.in").removeClass("in")
        
        

        $(this).parent().addClass("active")
        
        if (stat_id != "abstract"){
            $(".stage").addClass("hovered")
            $(".a-stat-desc.blurb").addClass("out")
            $(".stage").addClass("darkened")

            var stat_desc = $(".a-stat-desc[data-stat-id='"+stat_id+"']")
            stat_desc.addClass("in")

            var stat_vid = $(".stat-vids img[data-stat-id='"+stat_id+"']")
            stat_vid.addClass("in")
        }
        else {
            $(".stage").removeClass("darkened")
        }

        
        
        
    }, function(){
        //hover out!

        

        if (!$(".stage").hasClass("hovered")){
            $(".a-stat-desc.blurb").removeClass("out")
            $(".a-stat-desc").removeClass("in")
            $(".a-stat.active").removeClass("active")
            $(".stage").removeClass("darkened")
        }

        
    })


}
